import { useMemo } from "react";

import { useGetGiveaways } from "../../../api/insights";
import { RankedBarChart } from "../charts";
import SectionShell, { Stat, formatNum, formatPct } from "../SectionShell";

function Giveaway({ eventId }) {
  const { data, isPending, isError, error } = useGetGiveaways(eventId);

  const scansPerSponsor = useMemo(
    () =>
      (data?.scansPerSponsor ?? [])
        .map((s) => ({
          sponsor: s.name ?? "(unknown)",
          Scans: Number(s.scanCount ?? 0),
        }))
        .sort((a, b) => b.Scans - a.Scans),
    [data]
  );

  return (
    <SectionShell
      id="giveaway"
      title="Giveaway"
      description="Sponsor scan / giveaway participation."
      isPending={isPending}
      isError={isError}
      error={error}
      eventId={eventId}
      analysisKey="giveaway"
      stats={
        <>
          <Stat
            part="sponsors"
            label="Sponsors"
            value={formatNum(data?.totalSponsors)}
          />
          <Stat
            part="totalScans"
            label="Total scans"
            value={formatNum(data?.totalScans)}
          />
          <Stat
            part="participants"
            label="Participants"
            value={formatNum(data?.totalParticipants)}
          />
          <Stat
            part="completionRate"
            label="Completion rate"
            value={formatPct(data?.completionRate)}
          />
          {Number(data?.mostPopularSponsor?.scanCount) > 0 && (
            <Stat
              part="mostPopularSponsor"
              label="Most popular sponsor"
              value={data.mostPopularSponsor.name}
              hint={`${formatNum(data.mostPopularSponsor.scanCount)} scans`}
            />
          )}
        </>
      }
      lead={
        <RankedBarChart
          part="scansPerSponsor"
          title="Scans per sponsor"
          data={scansPerSponsor}
          categoryKey="sponsor"
          series={[{ name: "Scans", color: "blue.6" }]}
        />
      }
    />
  );
}

export default Giveaway;
